import {
  Component,
  EventEmitter,
  OnInit,
  Input,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  BusinessPersonSkeleton,
  BusinessPersonAudit
} from '../../+models/person-profile-audit.model';

@Component({
  selector: 'sd-portal-person-profile-business-person-audit-list',
  templateUrl: './person-profile-business-person-audit-list.component.html',
  styleUrls: ['./person-profile-business-person-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfileBusinessPersonAuditListComponent implements OnInit {
  @Input() businessPerson: BusinessPersonSkeleton;
  @Input() loading: boolean;
  @Input() businessPersonAudits: BusinessPersonAudit[];

  @Output() loadBusinessPersonAudits = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadBusinessPersonAudits.emit(this.businessPerson.businessPersonId);
  }

  onNextPage() {
    this.nextPage.emit(this.businessPerson.businessPersonId);
  }
}
